import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

const OvRecordDetailsCanvas = styled.div`
  background-color: ${Colours.WHITE};
  border-radius: ${Variables.borderRadius.LARGE};
  box-shadow: ${Variables.boxShadow.alternateBox};
  overflow: hidden;

  a {
    color: ${Colours.OV_BASE};
    text-underline-offset: 3px;
  }

  a:hover {
    color: ${Colours.OV_ACCENT_BLUE};
  }

  a:focus-visible {
    outline: 3px solid ${Colours.OV_ACCENT_BLUE};
    outline-offset: 2px;
  }
`;

export default OvRecordDetailsCanvas;
